var FormComponent = /** @class */ (function () {
    function FormComponent() {
        var _this = this;
        /**
         * Helper function for `this.form.get()`
         * with autocomplete and Non-Null Assertion Operator
         */
        this.getField = function (field) {
            if (!_this.form) {
                throw new Error("Form is undefined, cannot get field " + field);
            }
            return _this.form.get(field);
        };
        /**
         * Helper function for multiple `this.form.get()`
         * with autocomplete and Non-Null Assertion Operator
         */
        this.getFields = function () {
            var fields = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                fields[_i] = arguments[_i];
            }
            return fields.map(function (f) { return _this.getField(f); });
        };
        this.disableFields = function () {
            var fields = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                fields[_i] = arguments[_i];
            }
            return _this.getFields.apply(_this, fields).forEach(function (f) { return f.disable(); });
        };
        this.enableFields = function () {
            var fields = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                fields[_i] = arguments[_i];
            }
            return _this.getFields.apply(_this, fields).forEach(function (f) { return f.enable(); });
        };
    }
    return FormComponent;
}());
export { FormComponent };
